import loadable from '@loadable/component';
import type { FC } from 'react';
import React, { useMemo } from 'react';
import type { NodeViewRendererProps, NodeViewRenderers } from 'ricos-types';
import { Node_Type } from 'ricos-types';

const HtmlRenderer: FC<NodeViewRendererProps> = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  const Html = useMemo(
    () => loadable(() => import(/* webpackChunkName: "ricos_plugin_html" */ './html')),
    []
  );
  return (
    <Html
      key={node.id}
      node={node}
      nodeIndex={nodeIndex}
      NodeViewContainer={NodeViewContainer}
      {...props}
    />
  );
};

const HtmlLoadable = ({ node, ...props }: NodeViewRendererProps) => {
  return <HtmlRenderer key={node.id} node={node} {...props} />;
};

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.HTML]: HtmlLoadable,
};
